import { render } from "./MobileBar.vue?vue&type=template&id=d64b134c"
import script from "./MobileBar.vue?vue&type=script&lang=js"
export * from "./MobileBar.vue?vue&type=script&lang=js"

import "./MobileBar.vue?vue&type=style&index=0&id=d64b134c&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__